export const SET_BILLING_ACCOUNTS = "setBillingAccounts";
export const SET_BILLING_USERS = "setBillingUsers";
export const SET_DATE = "setDate";
export const SET_INVOICES = "setInvoices";
export const UPDATE_TOTAL_INVOICES = "updateTotalInvoices";
